export function getdata() {
  let obj = {
    headData:[
      {
        title: '数电票号码',
        prop: 'tes1',
        width: '150',
        issort: true,
        custom:true,
      },{
        title: '单据状态',
        prop: 'tes2',
        width: '100',
        custom:true,
        showFilter: true,
        checkList: ['1', '2'],
        dataList: [
          {
            name: "已开票",
            code: "1"
          }, {
            name: "已红冲",
            code: "2"
          }, {
            name: "已作废",
            code: "3"
          },
        ]
      }, {
        title: '发票用途',
        prop: 'tes3',
        width: '150',
        custom:true,
        showFilter: true,
        checkList: ['1'],
        dataList: [
          {
            name: "已申请代办退税",
            code: "1"
          },{
            name: "已勾选不抵扣 (历史数据)",
            code: "2"
          },{
            name: "不予退税",
            code: "3"
          },{
            name: "税(历史数据)",
            code: "4"
          },{
            name: "准予退税",
            code: "5"
          },{
            name: "已申请退税",
            code: "6"
          },{
            name: "出口转内销",
            code: "7"
          }
        ]
      },  {
        title: '入账状态',
        prop: 'tes4',
        width: '100',
        custom:true,
        showFilter: true,
        checkList: ['1','2'],
        dataList: [
          {
            name: "未入账",
            code: "1"
          },{
            name: "已入账",
            code: "1"
          },
        ]
      }, {
        title: '发票类型',
        prop: 'tes5',
        width: '100',
        custom:true,
        showFilter: true,
        checkList: ['1'],
        dataList: [
          {
            name: "电子普票",
            code: "1"
          }
        ]
      }, {
        title: '开票时间',
        prop: 'tes6',
        width: '100',
        issort: true,
      }, {
        title: '价税合计',
        prop: 'tes7',
        width: '100',
        issort: true,
        AmountFormat:true,
      },
      {
        title: '购方名称',
        prop: 'tes8',
        width: '200',
        issort: true,
      } ,{
        title: '任务批次号',
        prop: 'tes9',
        width: '200',
        issort: true,
      }, {
        title: '最近执行时间',
        prop: 'tes10',
        width: '200',
        issort: true,
      },{
        title: '任务完成时间',
        prop: 'tes11',
        width: '200',
        issort: true,
      },{
        title: '处理状态',
        prop: 'tes12',
        width: '100',
        showFilter: true,
				custom:true,
				checkList: [],
				dataList: [
					{
						name: "是",
						code: "0"
					},
					{
						name: "否",
						code: "1"
					},
				]
      },{
        title: '错误原因',
        prop: 'tes13',
        width: '100',
        issort: true,
      }
    ],
    //页码
    pagination: {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      paginationkey: 0
    },
  }
  return obj
}